import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-contact.component',
    templateUrl: 'contact.component.html',
    styleUrls: ['../pages.scss', 'contact.component.scss'],
})

export class ContactComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => {
          this.activeLanguage = val;
      });
    }
    headerContent = {
        german:  `
        <div class="row">
            <div class="col">
                <h1 class="header">Kontakt</h1>
            </div>
        </div>`,
        english: `
        <div class="row">
            <div class="col">
                <h1 class="header">Contact</h1>
            </div>
        </div>`,
    };
    content = {
        german: `
            <div class="text-content col">
            <h2 class="subheader margin-below">So erreichen Sie uns:</h2>
                <p>
                    Addresse:<br>
                    <b class="indent">
                        Technologie Consulting Wolke<br>
                        Reuteweg 3<br>
                        75382 Althengstett<br>
                    </b>
                </p>
                <p>
                    Telefon: <span class="bold">+49 7051 939926</span><br>
                    Handy: <span class="bold">+49 172 7019793</span><br>
                    Fax: <span class="bold">+49 7051 939925</span>
                </p>
                <p>
                    e-mail: <a href="mailto: tcw@wolke-consulting.com">tcw@wolke-consulting.com</a>
                </p>
                <p><span class="Highlight">Ich freue mich auf Ihre Kontaktaufnahme.</span></p>
            </div>
        `,
      english: `
        <div class="text-content col">
        <h2 class="subheader margin-below">How to reach us:</h2>
            <p>
                Address:<br>
                <b class="indent">
                    Technologie Consulting Wolke<br>
                    Reuteweg 3<br>
                    75382 Althengstett<br>
                    Germany
                </b>
            </p>
            <p>
                Telephone Office: <span class="bold">+49 7051 939926</span><br>
                Telephone Mobile: <span class="bold">+49 172 7019793</span><br>
                Fax: <span class="bold">+49 7051 939925</span>
            </p>
            <p>
                e-mail: <a href="mailto: tcw@wolke-consulting.com">tcw@wolke-consulting.com</a>
            </p>
            <p><span class="Highlight">I’m looking forward to talking to you!</span></p>
        </div>
    `,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.ts